export default "__VITE_ASSET__PeaJMXbo__"